module.exports = __webpack_public_path__ + "img/inst-modal-6.898adef2.png";